

























































































































































































































import { Component, Vue } from "vue-property-decorator";
import CustomLabel from "@/components/label.vue";
import CustomPhoneLabel from "@/components/phoneLabel.vue";
import CustomTimeLabel from "@/components/timeLabel.vue";
import CustomNumberLabel from "@/components/numberLabel.vue";
import CustomTable from "@/components/table.vue";
import MemberApi from "@/api/admin/member";
import WalletApi from "@/api/admin/wallet";
import GeneApi from "@/api/admin/gene";
import { MemberModel, WalletModel, WalletUpdateRequest, GeneInfoBeautyHealth, GeneResultItem } from "@/api/types";
import { relativeTimeThreshold } from "moment";
import moment from "moment";

@Component({
  components: {
    CustomLabel,
    CustomPhoneLabel,
    CustomTimeLabel,
    CustomNumberLabel,
    CustomTable,
  },
})
export default class MemberDetail extends Vue {
  geneCategoryHealth: GeneInfoBeautyHealth [] = [];
  geneCategoryBeauty: GeneInfoBeautyHealth [] = [];
  geneResult: GeneResultItem [] = [];

  member: MemberModel = {
name: "",
sex: "",
};
  wallets: WalletModel[] = [];
  pagination = false;
  visible = false;
  modalLoading = false;
  releaseMode = false;
  loadingHealth = false;
  loadingBeauty = false;
  isLoading= false;
  activeKey  = "1";
  wallet: WalletUpdateRequest = {
    amount: 0,
    description: "",
  };

  geneHealthColumns = [
    {
      width: 100,
      title: "항목",
      dataIndex: "name",
    },
    {
      width: 50,
      title: "GENE",
      dataIndex: "geneName",
    },
    {
      width: 50,
      align: "left",
      title: "SET1",
      dataIndex: "set1",
      scopedSlots: { customRender: "address" },
    },
    {
      width: 50,
      align: "rigleftt",
      title: "SET2",
      dataIndex: "set2",
      scopedSlots: { customRender: "balance" },
    },
    {
      width: 50,
      align: "left",
      title: "O . X",
      dataIndex: "",
      scopedSlots: { customRender: "check" },
    },
    {
      width: 70,
      align: "left",
      title: "상태",
      dataIndex: "",
      scopedSlots: { customRender: "status" },
    },
  ];
columns: any;
row: any;

  get walletsLength() {
    return this.wallets.length;
  }

  get lockupWallet() {
    return this.wallets.find((w) => w.type! == "1");
  }

  get coinWallet() {
    return this.wallets.find((w) => w.type! == "0");
  }

  mounted() {
    this.load();
    // this.loadGeneCategory();
    // this.loadGeneResult();
  }


  dateFormat(date: Date) {
    return moment(date).format("yyyy-MM-DD HH:mm");
  }

  loadSignInType(){
    if(this.member.kakao != null){
      return "카카오 로그인";
    }else if(this.member.naver != null){
      return "네이버 로그인";
    }else if(this.member.google != null){
      return "구글 로그인";
    }else{
      return "일반 로그인";
    }
  }

  async load(){
    await this.loadMember();
    await this.loadGeneCategory();
    await this.loadGeneResult();
  }

  async loadMember() {
    const { id , activeKey} = this.$route.query as { id: string , activeKey: string};
    let result = await MemberApi.single(id);
    this.member = result;
  }

  async loadGeneResult() {
    const { id , activeKey} = this.$route.query as { id: string , activeKey: string};
    // this.activeKey  = this.$route.query as { activeKey: string };

    this.activeKey = activeKey;

    var result = await GeneApi.result(id);
    // let health = result.itemList.findAll((w) => w.type == "HEALTH");
    if( result.result !== false){
      let health = result.itemList.filter((item: { type: string | string[]; }) => item.type.indexOf('HEALTH') !==  -1);
      let beauty = result.itemList.filter((item: { type: string | string[]; }) => item.type.indexOf('BEAUTY') !==  -1);

      for(let i=0; i<this.geneCategoryHealth.length; i++){
        let rs = health.find((w: { geneName: string | undefined; }) => w.geneName == this.geneCategoryHealth[i].geneName);
        if(rs !== undefined){
          // this.geneCategoryHealth[i].customCode = rs.code;
          //   this.geneCategoryHealth[i].customResult = rs.result;
          //   this.geneCategoryHealth[i].customSet1 = rs.result.substr(0,1);
          //   this.geneCategoryHealth[i].customSet2 = rs.result.substr(1,1);
          if(this.geneCategoryHealth[i].setNormal == "1"){
            this.geneCategoryHealth[i].customCode = rs.code;
            this.geneCategoryHealth[i].customResult = rs.result;
            this.geneCategoryHealth[i].customSet1 = rs.result.substr(0,1);
            this.geneCategoryHealth[i].customSet2 = rs.result.substr(1,1);
            this.geneCategoryHealth[i].customResultText = rs.resultText;
          }else { 
            this.geneCategoryHealth[i].customCode = rs.code;
            this.geneCategoryHealth[i].customResult = rs.result;
            this.geneCategoryHealth[i].customSet1 = rs.result.substr(1,1);
            this.geneCategoryHealth[i].customSet2 = rs.result.substr(0,1);
            this.geneCategoryHealth[i].customResultText = rs.resultText;
          }
         
        }
      }

      for(let i=0; i<this.geneCategoryBeauty.length; i++){
        let rs = beauty.find((w:any) => w.geneName == this.geneCategoryBeauty[i].geneName);
        if(rs !== undefined){
          if(this.geneCategoryBeauty[i].setNormal == "1"){
            this.geneCategoryBeauty[i].customCode = rs.code;
            this.geneCategoryBeauty[i].customResult = rs.result;
            if(rs.result.length == 4){
              this.geneCategoryBeauty[i].customSet1 = rs.result.substr(0,2);
              this.geneCategoryBeauty[i].customSet2 = rs.result.substr(2,2);
            }else{
              this.geneCategoryBeauty[i].customSet1 = rs.result.substr(0,1);
            this.geneCategoryBeauty[i].customSet2 = rs.result.substr(1,1);
            }
            
            this.geneCategoryBeauty[i].customResultText = rs.resultText;
          }else { 
            this.geneCategoryBeauty[i].customCode = rs.code;
            this.geneCategoryBeauty[i].customResult = rs.result;
            if(rs.result.length == 4){
              this.geneCategoryBeauty[i].customSet1 = rs.result.substr(0,2);
              this.geneCategoryBeauty[i].customSet2 = rs.result.substr(2,2);
            }else{
              this.geneCategoryBeauty[i].customSet1 = rs.result.substr(0,1);
            this.geneCategoryBeauty[i].customSet2 = rs.result.substr(1,1);
            }
            this.geneCategoryBeauty[i].customResultText = rs.resultText;
          }
        }
      }
    }


    this.loadingHealth = true;
    this.loadingBeauty = true;
    this.isLoading = true;
  }

  async save() {

    if (window.confirm("유전자 검사 결과를 저장할까요?")) {
      for(let i=0; i<this.geneCategoryHealth.length; i++) {
        if(this.geneCategoryHealth[i].customResult != null){
          this.geneResult.push(
            {
              type:"HEALTH",
              code:this.geneCategoryHealth[i].customCode,
              geneName: this.geneCategoryHealth[i].geneName,
              result: this.geneCategoryHealth[i].customResult,
              resultText: this.geneCategoryHealth[i].customResultText,
            }
          )
        }
      }

      for(let i=0; i<this.geneCategoryBeauty.length; i++) {
        if(this.geneCategoryBeauty[i].customResult != null){
          this.geneResult.push(
            {
              type:"BEAUTY",
              code:this.geneCategoryBeauty[i].customCode,
              geneName: this.geneCategoryBeauty[i].geneName,
              result: this.geneCategoryBeauty[i].customResult,
              resultText: this.geneCategoryBeauty[i].customResultText,
            }
          )
        }
      }
      const { id } = this.$route.query as { id: string };
      var rs = await GeneApi.save(id ,this.geneResult); 
      if(rs.code != null){
        alert("저장완료");
        window.location.reload();
      }else{
        alert("오류가발생했습니다. 관리자에게 문의해주세요.");
      }
    }

  }

  async loadGeneCategory() {
    let resultHealth = await GeneApi.geneInfo("HEALTH");
    let resultBeauty = await GeneApi.geneInfo("BEAUTY");

    this.geneCategoryHealth = [...resultHealth.data];
    this.geneCategoryBeauty = [...resultBeauty.data];
  }

  handleChange(value: number) {
    this.member.type = value;
  }


  async changeStatus(row: any) {
    this.loadingHealth = false;
    if(row.setNormal == "1"){
      if(row.set1 + row.set1 == row.customSet1 + row.customSet2){
        row.customResult = row.customSet1 + row.customSet2;
        row.customResultPer = row.geneTestGoodPer;
        row.customResultText = "good"
      }else if(row.set1 + row.set2 == row.customSet1 + row.customSet2){
        row.customResult = row.customSet1 + row.customSet2;
        row.customResultPer = row.geneTestAttentionPer;
        row.customResultText = "attention";
      }else if(row.set2 + row.set2 == row.customSet1 + row.customSet2){
        row.customResult = row.customSet1 + row.customSet2;
        row.customResultPer = row.geneTestCautionPer;
        row.customResultText = "caution";
      }else{
        row.customResult = null;
      }
    }else{
      if(row.set2 + row.set2 == row.customSet1 + row.customSet2){
        row.customResult = row.customSet2 + row.customSet1;
        row.customResultPer = row.geneTestGoodPer;
        row.customResultText = "good";
      }else if(row.set1 + row.set2 == row.customSet1 + row.customSet2){
        row.customResult = row.customSet2 + row.customSet1;
        row.customResultPer = row.geneTestAttentionPer;
        row.customResultText = "attention";
      }else if(row.set1 + row.set1 == row.customSet1 + row.customSet2){
        row.customResult = row.customSet2 + row.customSet1;
        row.customResultPer = row.geneTestCautionPer;
        row.customResultText = "caution";
      }else{
        row.customResult = null;
      }
    }
    this.loadingHealth = true;
      
  }

  numberFormat(value: string) {
    if (value == null) {
      return "-";
    }
    const regexp = /\B(?=(\d{3})+(?!\d))/g;
    return value.toString().replace(regexp, ",") + " HITOP";
  }

  showModal(isRelease: boolean) {
    this.releaseMode = isRelease;
    this.visible = true;
  }

  async update() {
    const { id } = this.$route.query as { id: string };
    this.member = await MemberApi.update(id, this.member);
    console.log(this.member);
  }

  async handleOk() {
    this.modalLoading = true;
    if (this.releaseMode) {
      const result = await WalletApi.release(this.member!.id!, this.wallet);
      if (result.result == false) {
        if (result.codeName == "LEAK_BALANCE") {
          this.$message.error(result.message);
        }
      }
    } else {
      await WalletApi.update(this.lockupWallet!.id!, this.wallet);
    }
    await this.load();
    this.resetDatum();
    this.modalLoading = false;
    this.visible = false;
  }

  handleCancel() {
    this.visible = false;
    this.resetDatum();
  }

  resetDatum() {
    this.wallet = {
      amount: 0,
      description: "",
    };
  }

  rowClick(record: WalletModel) {
    this.$router.push({ name: "memberHistory", query: { id: record.id } });
  }
}
interface KeywordModel {
  value: number;
  title: string;
}
